import { faCompass } from '@fortawesome/pro-solid-svg-icons';

import { useTranslate } from '@growtherapy/i18n';

import { ControlPanelButton, ControlPanelButtonTooltip } from '../../components/ControlPanelButton';
import { DrawerButton } from '../../components/DrawerButton';
import { IconMenuItem } from '../../components/IconMenuItem';
import { MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from '../constants';
import { VisitorDrawerState } from '../state';
import { useIntentionsDrawerControls } from './useIntentionsDrawerControls';

export type IntentionsDrawerControlsProps = {
  className?: string;
  drawerId: string;
  isDrawerOpen: boolean;
  onClick: () => void;
  tooltipText: string;
};

export function IntentionsDrawerControls({
  className,
  drawerId,
  isDrawerOpen,
  onClick,
  tooltipText,
}: IntentionsDrawerControlsProps) {
  return (
    <div className={className}>
      <ControlPanelButtonTooltip childIsInteractive text={tooltipText}>
        <DrawerButton
          forDrawerStates={VisitorDrawerState.INTENTIONS}
          aria-label={tooltipText}
          aria-expanded={isDrawerOpen}
          aria-controls={drawerId}
          iconDefinition={faCompass}
          as={ControlPanelButton}
          onClick={onClick}
        />
      </ControlPanelButtonTooltip>
    </div>
  );
}

export function IntentionsDrawerControlsWrapper(props: Pick<IntentionsDrawerControlsProps, 'className'>) {
  const { helperText, isDrawerOpen, onClick, shouldShowButton } = useIntentionsDrawerControls();

  return shouldShowButton ? (
    <IntentionsDrawerControls
      {...props}
      drawerId={MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
      isDrawerOpen={isDrawerOpen}
      onClick={onClick}
      tooltipText={helperText}
    />
  ) : null;
}

export type IntentionsDrawerControlMenuItemProps = {
  className?: string;
  drawerId: string;
  helperText: string;
  isDrawerOpen: boolean;
  onClick: () => void;
};

export function IntentionsDrawerControlMenuItem({
  className,
  drawerId,
  helperText,
  isDrawerOpen,
  onClick,
}: IntentionsDrawerControlMenuItemProps) {
  const t = useTranslate();
  return (
    <IconMenuItem
      aria-controls={drawerId}
      aria-expanded={isDrawerOpen}
      onClick={onClick}
      className={className}
      icon={faCompass}
    >
      <span className='sr-only'>{helperText}</span>
      <span aria-hidden>{t('telehealth-core:controls.intentions')}</span>
    </IconMenuItem>
  );
}

export function IntentionsDrawerControlMenuItemWrapper(props: Pick<IntentionsDrawerControlMenuItemProps, 'className'>) {
  const { helperText, isDrawerOpen, onClick, shouldShowButton } = useIntentionsDrawerControls();

  return shouldShowButton ? (
    <IntentionsDrawerControlMenuItem
      className={props.className}
      drawerId={MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
      helperText={helperText}
      isDrawerOpen={isDrawerOpen}
      onClick={onClick}
    />
  ) : null;
}
